import { render, staticRenderFns } from "./OrderSave.vue?vue&type=template&id=36588ad9&scoped=true"
import script from "./OrderSave.vue?vue&type=script&lang=js"
export * from "./OrderSave.vue?vue&type=script&lang=js"
import style0 from "./OrderSave.vue?vue&type=style&index=0&id=36588ad9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36588ad9",
  null
  
)

export default component.exports